
import { createContext } from 'react';

const OrientationContext = createContext<any>(null);
const OrientationProvider = OrientationContext.Provider


export { OrientationContext, OrientationProvider }
